export type SecondaryTermId =
  | 'net-30'
  | 'remittance-advice'
  | 'credit-memo'
  | 'unapplied-cash'
  | 'po-matching';

export interface SecondaryTermEntry {
  id: SecondaryTermId;
  title: string;
  definition: string;
}

export const SECONDARY_TERMS: Record<SecondaryTermId, SecondaryTermEntry> = {
  'net-30': {
    id: 'net-30',
    title: 'Net 30',
    definition:
      'Payment terms: invoice is due in 30 days from issue date. "2/10 Net 30" means 2% discount if paid within 10 days, otherwise full amount in 30.',
  },
  'remittance-advice': {
    id: 'remittance-advice',
    title: 'remittance advice',
    definition:
      'A note (email, attached PDF, or spreadsheet) telling AR which invoices a payment covers. Without it, cash application is guesswork.',
  },
  'credit-memo': {
    id: 'credit-memo',
    title: 'credit memo',
    definition:
      'A negative invoice — the company owes the customer money or is forgiving part of an invoice. Often tied to disputes or returns.',
  },
  'unapplied-cash': {
    id: 'unapplied-cash',
    title: 'unapplied cash',
    definition:
      "Money received but not yet matched to an invoice. Sits in a holding account until the clerk figures out where it belongs.",
  },
  'po-matching': {
    id: 'po-matching',
    title: 'PO matching',
    definition:
      'Confirming the invoice line items match the original purchase order. A common dispute trigger when amounts or quantities differ.',
  },
};
